import { useMutation, useQueryClient } from 'react-query';
import { getProductScope } from '@discover-frontend/utils';

import { STANLEY_QUERY_KEYS } from '../constants';
import { deleteStanleyQueryHistoryItem } from '../request';
import {
  DeleteStanleyQueryHistoryItemParams,
  StanleyQueryHistoryListResponse,
} from '../types';

export const useDeleteStanleyQueryHistoryItem = () => {
  const queryClient = useQueryClient();
  const scope = getProductScope();
  const historyKey = [STANLEY_QUERY_KEYS.GET_HISTORY, scope];

  return useMutation(
    [STANLEY_QUERY_KEYS.DELETE_HISTORY_ITEM],
    (params: DeleteStanleyQueryHistoryItemParams) =>
      deleteStanleyQueryHistoryItem(params),
    {
      onMutate: async (params) => {
        await queryClient.cancelQueries(historyKey);

        const previous =
          queryClient.getQueryData<StanleyQueryHistoryListResponse>(historyKey);

        if (previous) {
          queryClient.setQueryData<StanleyQueryHistoryListResponse>(
            historyKey,
            previous.filter((item) => item.run_id !== params.run_id)
          );
        }

        return { previous };
      },
      onError: (_error, _params, context) => {
        if (context?.previous) {
          queryClient.setQueryData(historyKey, context.previous);
        }
        queryClient.invalidateQueries(historyKey);
      },
    }
  );
};
